namespace advisorop.components.common {


    export class CuUserHierarchyController {

        // input property - for parent user
        parentUser: domains.IUser;

        // company group id
        companyGroupId: number;

        // crud 
        userHierarchy: domains.IUsersHierarchy = {};

        // list
        userHierarchies: domains.IUsersHierarchy[];

        // grid
        dgUserHierarchy: DevExpress.ui.dxDataGridOptions;

        // reference
        iAmReady: any; //event when controller has been initialised

        // relation type
        selRelationType: { id: domains.UserHierarchyRelation, name: string };

        // posible child users
        childUsers: domains.IUser[];

        // selected Child UserId
        selChildUser: domains.IUser;

        // edit mode ?
        isEditMode = true;

        mainPanel: advisorop.components.widgets.AdvisoropPanelController;

        relationTypes = [
            {
                id: domains.UserHierarchyRelation.ADVISORY_ADVISORY,
                name: 'Has child advisor', // advisor-advisor relation
            }, {
                id: domains.UserHierarchyRelation.SERVICER_SERVICER,
                name: 'Has child servicer', // servicer-servicer relation
            }];

        advisorRelationTypes = [
            {
                id: domains.UserHierarchyRelation.ADVISORY_ADVISORY,
                name: 'Has child advisor', // advisor-advisor relation
            }
        ];

        static $inject = ["servicerService","advisorService", "generalService", "identityService"];
        constructor(
            private ss: services.ServicerService,
            private ads: services.AdvisorService,
            private gs: services.GeneralService,
            private ids: services.IdentityService) {  
            this.dgUserHierarchy = {
                export: {
                    enabled: true,
                    fileName: "user-hierarchy"
                },
                bindingOptions: {
                    dataSource: "vm.userHierarchies"
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                // noDataText: "There are no users hierarchy",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "parentUserFullName", caption: "Parent user" },
                    {
                        dataField: "userHierarchyRelation", lookup: {
                            dataSource: this.relationTypes,
                            displayExpr: "name",
                            valueExpr: "id"
                        }, caption: "Relation"
                    },
                    { dataField: "childUserFullName", caption: "Child user" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "175" }
                ]
            };
        }

        async onSave() {
            this.userHierarchy.childUserId = this.selChildUser.id;
            this.userHierarchy.parentUserId = this.parentUser.id;
            this.userHierarchy.userUserHierarchyRelation = this.selRelationType.id;

            this.mainPanel.showLoadingPanel();
            let rez1 = await this.ids.saveUserHierarchy(this.userHierarchy)
                .catch(err => this.gs.showError(err))
                .finally(() => {
                    this.mainPanel.hideLoadingPanel();
                    this.isEditMode = false;
                });

            await this.loadUserHierarchies(this.parentUser.id);
            
            return rez1;
        }

        async onDelete(relation: domains.IUsersHierarchy) {

            if (window.confirm(`You are going to delete this record. Are you sure ?`)) {

                this.mainPanel.showLoadingPanel();
                let rez1 = await this.ids.deleteUserHierarchy(relation.id)
                    .catch(err => this.gs.showError(err))
                    .finally(() => this.mainPanel.hideLoadingPanel());

                await this.loadUserHierarchies(this.parentUser.id);

                return rez1;
            }
        }

        onCancel = () => {
            this.isEditMode = false;
        }

        onRelationTypeChanged = () => {
            if (!this.selRelationType)
                return;

            if (this.selRelationType.id == domains.UserHierarchyRelation.ADVISORY_ADVISORY) {
                this.loadAdvisors();
            } else if (this.selRelationType.id == domains.UserHierarchyRelation.SERVICER_SERVICER) {
                this.loadServicers();
            } else {
                return;
            }
        }

        onChildUserSelected($item, $model, $label, $event) {

        }

        //onSearchChildUsers($viewValue) {
        //    return [];
        //}

        onMainPanelReady(ctrl) {
            this.mainPanel = ctrl;
        }

        showLoadingPanel() {
            if (this.mainPanel)
            this.mainPanel.showLoadingPanel();
        }

        hideLoadingPanel() {
            if (this.mainPanel)
            this.mainPanel.hideLoadingPanel();
        }

        async loadUserHierarchies(parentUserId) {
            //console.log("loading hierarchies from user ", parentUserId);
            this.showLoadingPanel();
            return this.ids.getUserHierarchy(parentUserId)
                .then(response => {
                    this.userHierarchies = response.data;
                    this.isEditMode = !(this.userHierarchies.length > 0);
                }, err => toastr.error("Product list can not be loaded. " + err.data))
                .finally(() => this.hideLoadingPanel());;
        };

        async loadAdvisors() {
            const user = await this.ids.getUserPromise();
            if (user.systemLoginType == domains.SystemLoginType.SERVICER) {
                this.showLoadingPanel();
                return this.ss.getAdvisors(this.companyGroupId)
                    .then(resp => {
                        this.childUsers = resp.data
                            .filter(f => f.systemLogin.username != this.parentUser.username)
                            .map(m => { return { ...m.systemLogin, firstName: m.firstName, lastName: m.lastName, fullName: m.fullName }; });
                    }, err => this.gs.showError(err))
                    .finally(() => this.hideLoadingPanel());
            } else {
                this.showLoadingPanel();
                return this.ads.getAdvisorsForCurrentAdvisor()
                    .then(resp => {
                        this.childUsers = resp.data
                            .filter(f => f.systemLogin.username != this.parentUser.username)
                            .map(m => { return { ...m.systemLogin, firstName: m.firstName, lastName: m.lastName, fullName: m.fullName }; });
                    }, err => this.gs.showError(err))
                    .finally(() => this.hideLoadingPanel());
            }
        }

        async loadServicers() {
            this.showLoadingPanel();
            return this.ss.getServicers()
                .then(resp => {
                    this.childUsers = resp.data
                        .filter(f => f.username != this.parentUser.username);
                }, err => this.gs.showError(err))
                .finally(() => this.hideLoadingPanel());
        }
        
        $routerOnActivate(next, previous) {
        }

        $onInit(): void {
            this.iAmReady({ ctrl: this });
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "parentUser" && this.parentUser) {
                    this.loadUserHierarchies(this.parentUser.id);

                }
            }
        }
    }


    class CuUserHierarchy implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                iAmReady: "&",
                parentUser: "<",
                companyGroupId: "<"
            };
            this.controller = CuUserHierarchyController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/shared/common/cu-user-hierarchy.html";
        }
    }
    angular.module(Constants.APP).component("cuUserHierarchy", new CuUserHierarchy());
}